require('../../modules/es6.math.hypot');
module.exports = require('../../modules/_core').Math.hypot;
